import type { ProjectDocument } from '@bigint-project/cloud-contracts';
import type { ReactElement } from 'react';

interface ConflictPanelProps {
  readonly localProject: ProjectDocument;
  readonly busy: boolean;
  readonly onReload: () => void;
  readonly onExport: () => void;
  readonly onSaveCopy: () => void;
}

export function ConflictPanel({ localProject, busy, onReload, onExport, onSaveCopy }: ConflictPanelProps): ReactElement {
  return (
    <section className="conflict-panel" role="alert" aria-labelledby="conflict-heading">
      <div>
        <p className="eyebrow">並行修改保護</p>
        <h2 id="conflict-heading">雲端版本已被其他人更新</h2>
        <p>系統沒有覆蓋你目前的修改。請先匯出本地副本，或選擇如何處理。</p>
      </div>
      <div className="conflict-actions">
        <button type="button" onClick={onExport}>匯出本地 .bproj</button>
        <button type="button" className="secondary" disabled={busy} onClick={onSaveCopy}>
          另存成新專案
        </button>
        <button type="button" className="danger" disabled={busy} onClick={onReload}>
          捨棄本地修改並重新載入
        </button>
      </div>
      <p className="muted">本地專案：{localProject.name}</p>
    </section>
  );
}
